<template>
  <section class="proposals-form">
    <embed-frame
      class="proposals-form-frame"
      endpoint="proposals/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'ProposalsForm',
    components: {
      EmbedFrame,
    },
    computed: {
      ...mapState([
        'auth',
      ]),

      embedSettings() {
        const {
          proposal_id: proposalID,
          proposal_attempt_id: proposalAttemptID,
        } = this.$route.params;

        const {
          store_id: storeID,
          customer_id: customerID,

          condition_ids: conditionIDs,

          simulation_uuids: simulationUUIDs,
          simulation_uuid: simulationUUID,
        } = this.$route.query;

        const settings = {
          store_id: storeID,
          customer_id: customerID,

          id: proposalID,
          proposal_attempt: {
            id: proposalAttemptID,
          },

          condition_ids: conditionIDs,
        };

        if (simulationUUIDs) {
          settings.simulation_uuids = simulationUUIDs;
        } else {
          settings.simulation_uuid = simulationUUID;
        }

        return {
          proposals: {
            form: settings,
          },
        };
      },
      embedCallbacks() {
        return {
          'proposal:create': this.proposalSuccess,
          'proposal_attempt:create': this.proposalSuccess,
          'proposal_attempt:update': this.proposalSuccess,
        };
      },
    },
    methods: {
      proposalSuccess(data) {
        this.$router.push({
          name: 'proposals-read',
          params: {
            id: this.$route.params.proposal_id || (
              data.proposal_attempt
                ? data.proposal_attempt.proposal_id
                : data.complete_proposal.id
            ),
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
